import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import actions from '../../store/actions/edit-document.actions';
import documentEditMode from '../../constants/documentEditMode';
import EditableItem from '../../EditableItem/EditableItem';

const ResponseTimeCell = memo(
  ({ record, getPopupContainer = () => document.body }) => {
    const dispatch = useDispatch();

    return (
      <EditableItem
        allowedForAppointedWorker
        record={record}
        editText={
          record.doneDate ? 'Изменить срок ответа' : 'Добавить срок ответа'
        }
        onClick={(e) => {
          e.stopPropagation();
          dispatch(
            actions.openModal({
              ...record,
              editMode: documentEditMode.RESPONCE_TIME,
            })
          );
        }}
        itemText={
          record.deadlineDate
            ? `${moment(record.deadlineDate).format('DD.MM.YYYY')}`
            : 'Не указан'
        }
        getPopupContainer={getPopupContainer}
      />
    );
  }
);

export default ResponseTimeCell;
